const $ = jQuery;

const data = {
    category: new URLSearchParams(window.location.search).get('category') || '',
    posts: [],
};

const productContainer = document.querySelector('.js-product-archive-container');
const filterButtons = document.querySelectorAll('.js-filter-category');

export default function productArchive() {
    initializeCategories();
}

function initializeCategories() {
    filterButtons.forEach(button => {
        button.addEventListener('click', function () {
            const categorySlug = button.getAttribute('data-filter');
            if (categorySlug) {
                const url = '/kategorija/' + categorySlug;
                window.location.href = url;
            } else {
                activateDefaultFilter();
            }
        });
    });

    // If no category in the url, activate the first button
    if (!data.category) {
        activateDefaultFilter();
    }
}

function activateDefaultFilter() {
    filterButtons.forEach(button => {
        if (button.getAttribute('data-filter') === '') {
            button.classList.add('active');
        }
    });
}